othIsArr